import { NavLink, useNavigate } from 'react-router-dom';
import Logo from '../assets/images/logo.svg';
import ProfileSettings from './ProfileSettings';

const Navbar = () => {
  const navigate = useNavigate();
  return (
    <div
      className="
        bg-[#fcfcfc] dark:bg-[#141414] max-w-[260px] w-[260px] drop-shadow-md grow flex
         flex-col sm:h-full justify-between fixed sm:static top-[50px] shrink-0"
    >
      <div
        className="flex items-center cursor-pointer p-5"
        onClick={() => navigate('/')}
      >
        <img src={Logo} className="w-[30px] h-[30px]" alt="logo" />
        <span className="font-semibold text-2xl pl-2 dark:text-[#bdbdbd]">
          Answerr
        </span>
      </div>
      <div className="w-full px-5 grow overflow-y-auto pt-3">
        <ul className="mt-4 mb-4">
          <li
            className="
              group relative min-w-0 flex items-center rounded-[3px]
              text-[#64645f] dark:text-[#bdbdbd] transition
               cursor-pointer font-normal text-[16px]
            "
          >
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                `p-3 w-full ${
                  isActive
                    ? 'bg-[#f3f3f3] dark:bg-[#424242]'
                    : 'hover:bg-[#f3f3f3] dark:hover:bg-[#424242]'
                }`
              }
            >
              Dashboard
            </NavLink>
          </li>
          <li
            className="
              group relative min-w-0 flex items-center rounded-[3px]
              text-[#64645f] dark:text-[#bdbdbd] transition
               cursor-pointer font-normal text-[16px]
            "
          >
            <NavLink
              to="/users"
              className={({ isActive }) =>
                `p-3 w-full ${
                  isActive
                    ? 'bg-[#f3f3f3] dark:bg-[#424242]'
                    : 'hover:bg-[#f3f3f3] dark:hover:bg-[#424242]'
                }`
              }
            >
              Users
            </NavLink>
          </li>
          <li
            className="
              group relative min-w-0 flex items-center rounded-[3px]
              text-[#64645f] dark:text-[#bdbdbd] transition
              cursor-pointer font-normal text-[16px]
            "
          >
            <NavLink
              to="/subscription-payments"
              className={({ isActive }) =>
                `p-3 w-full ${
                  isActive
                    ? 'bg-[#f3f3f3] dark:bg-[#424242]'
                    : 'hover:bg-[#f3f3f3] dark:hover:bg-[#424242]'
                }`
              }
            >
              Subscription Payments
            </NavLink>
          </li>
          <li
            className="
              group relative min-w-0 flex items-center rounded-[3px]
              text-[#64645f] dark:text-[#bdbdbd] transition
              cursor-pointer font-normal text-[16px]
            "
          >
            <NavLink
              to="/subscription-plans"
              className={({ isActive }) =>
                `p-3 w-full ${
                  isActive
                    ? 'bg-[#f3f3f3] dark:bg-[#424242]'
                    : 'hover:bg-[#f3f3f3] dark:hover:bg-[#424242]'
                }`
              }
            >
              Subscription Plans
            </NavLink>
          </li>
          <li
            className="
              group relative min-w-0 flex items-center rounded-[3px]
              text-[#64645f] dark:text-[#bdbdbd] transition
              cursor-pointer font-normal text-[16px]
            "
          >
            <NavLink
              to="/aiq-payments"
              className={({ isActive }) =>
                `p-3 w-full ${
                  isActive
                    ? 'bg-[#f3f3f3] dark:bg-[#424242]'
                    : 'hover:bg-[#f3f3f3] dark:hover:bg-[#424242]'
                }`
              }
            >
              AIQ Payments
            </NavLink>
          </li>
          <li
            className="
              group relative min-w-0 flex items-center rounded-[3px]
              text-[#64645f] dark:text-[#bdbdbd] transition
              cursor-pointer font-normal text-[16px]
            "
          >
            <NavLink
              to="/ai-models"
              className={({ isActive }) =>
                `p-3 w-full ${
                  isActive
                    ? 'bg-[#f3f3f3] dark:bg-[#424242]'
                    : 'hover:bg-[#f3f3f3] dark:hover:bg-[#424242]'
                }`
              }
            >
              AI Models
            </NavLink>
          </li>
          <li
            className="
              group relative min-w-0 flex items-center rounded-[3px]
              text-[#64645f] dark:text-[#bdbdbd] transition
              cursor-pointer font-normal text-[16px]
            "
          >
            <NavLink
              to="/organisations"
              className={({ isActive }) =>
                `p-3 w-full ${
                  isActive
                    ? 'bg-[#f3f3f3] dark:bg-[#424242]'
                    : 'hover:bg-[#f3f3f3] dark:hover:bg-[#424242]'
                }`
              }
            >
              Organisations
            </NavLink>
          </li>

          <li
            className="
              group relative min-w-0 flex items-center rounded-[3px]
              text-[#64645f] dark:text-[#bdbdbd] transition
              cursor-pointer font-normal text-[16px]
            "
          >
            <NavLink
              to="/configurations"
              className={({ isActive }) =>
                `p-3 w-full ${
                  isActive
                    ? 'bg-[#f3f3f3] dark:bg-[#424242]'
                    : 'hover:bg-[#f3f3f3] dark:hover:bg-[#424242]'
                }`
              }
            >
              Configurations
            </NavLink>
          </li>
        </ul>
      </div>
      <ProfileSettings />
    </div>
  );
};

export default Navbar;
